export class UnitSizes {
  shortName?: string;
  name: string;
  squareFeet: any;
  name2?: string;
  squareFeet2?: string;
  description?: string;
  img?: string;
  equivalent?: string;
  cc?: boolean;
  index?: string;
  _$visited?: any;
  imageAltText?: string;

  constructor() {
    this.cc = false;
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/unitSizes.ts